const label = {
  author: require("./author"),
  description: require("./description"),
  hashtag: require("./hashtag"),
  title: require("./title"),
  user: require("./user"),
};

module.exports = label;
